<template>
  <div
    v-if="connectionState.phase === 'connected'"
    class="flex items-center gap-2 text-sm text-green-600"
    :title="`Q-Tool verbunden mit ${connectionState.device.name}`"
  >
    <div
      class="grid transition-all duration-500 ease-in-out"
      :class="
        showConnectedLabel
          ? 'grid-cols-[1fr] opacity-100'
          : 'grid-cols-[0fr] opacity-0'
      "
    >
      <div class="overflow-hidden flex items-center gap-2 whitespace-nowrap">
        <span class="font-bold">Q-Tool</span>
        <span class="text-light-disabled-text dark:text-dark-disabled-text"
          >—</span
        >
        <span>Verbunden mit "{{ connectionState.device.name }}"</span>
      </div>
    </div>
    <em
      class="mdi mdi-bluetooth-connect transition-all duration-500"
      :class="showConnectedLabel ? 'text-xl' : 'text-lg animate-pulse'"
    />
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, ref, watch } from 'vue';
import type { QToolConnectionPhase } from '@/composables/useQToolConnection';

const props = defineProps<{
  connectionState: QToolConnectionPhase;
}>();

const showConnectedLabel = ref(false);
let collapseTimeout: ReturnType<typeof setTimeout> | undefined;

watch(
  () => props.connectionState.phase,
  (phase, previousPhase) => {
    if (collapseTimeout) {
      clearTimeout(collapseTimeout);
      collapseTimeout = undefined;
    }
    const freshConnection =
      phase === 'connected' &&
      previousPhase !== undefined &&
      previousPhase !== 'connected';
    if (freshConnection) {
      showConnectedLabel.value = true;
      collapseTimeout = setTimeout(() => {
        showConnectedLabel.value = false;
      }, 2000);
    } else {
      showConnectedLabel.value = false;
    }
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  if (collapseTimeout) {
    clearTimeout(collapseTimeout);
  }
});
</script>
